import { Component, Input } from '@angular/core';
@Component({
    styleUrls: ['./list-tile.component.scss'],
    templateUrl: './list-tile.component.html',
    selector: 'ca-list-tile',
    standalone: false
})
export class ListTileComponent {
  @Input() leadingIcon: string;
  @Input() title: string;
  @Input() trailingIcon: string;
  @Input() subtitle: string;
  @Input() disabled = false;
}
